exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-visitor-form .modal-dialog{margin:25vh auto}.v-visitor-form .modal-header{background-color:#008f90;color:#0a2e2e}.v-visitor-form .modal-header .close{color:#0a2e2e;opacity:.6}.v-visitor-form .modal-header .close:hover{opacity:1}.v-visitor-form .modal-body .form .form-group{margin-bottom:25px}.v-visitor-form .modal-body .form .form-group .form-control:not(button){margin-top:5px;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46944446","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/VisitorForm.vue
// module id = 3+ZO
// module chunks = 0